
export const educationalItems  = [

    {
        id: "wgu",
        school: "Western Governors University",
        dates: "Graduated July 2025",
        degree: "Bachelor of Science in Computer Software Engineering"
    }
]
